export enum LazoConversationReadStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}
